import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  data: [],
  fieldsData: [],
  typeList: [],
  subTypeList: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET:
      return { ...state, isLoading: true };
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };
    case actionTypes.GET_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE_TABLE:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_TABLE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };
    case actionTypes.CREATE_TABLE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.MODIFY_TABLE:
      return { ...state, isLoading: true };
    case actionTypes.MODIFY_TABLE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };
    case actionTypes.MODIFY_TABLE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE_TABLE:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_TABLE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };
    case actionTypes.DELETE_TABLE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_FIELDS:
      return { ...state, isLoading: true };
    case actionTypes.GET_FIELDS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        fieldsData: action.payload.data,
        typeList: action.payload.typeList,
        subTypeList: action.payload.subTypeList,
      };
    case actionTypes.GET_FIELDS_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE_FIELD:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_FIELD_FULFILLED:
      return {
        ...state,
        isLoading: false,
        fieldsData: action.payload.data,
      };
    case actionTypes.CREATE_FIELD_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE_FIELD:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_FIELD_FULFILLED:
      return {
        ...state,
        isLoading: false,
        fieldsData: action.payload.data,
      };
    case actionTypes.DELETE_FIELD_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.MODIFY_FIELD:
      return { ...state, isLoading: true };
    case actionTypes.MODIFY_FIELD_FULFILLED:
      return {
        ...state,
        isLoading: false,
        fieldsData: action.payload.data,
      };
    case actionTypes.MODIFY_FIELD_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.MODIFY_FIELD_OPTION:
      return { ...state, isLoading: true };
    case actionTypes.MODIFY_FIELD_OPTION_FULFILLED:
      return {
        ...state,
        isLoading: false,
        fieldsData: action.payload.data,
      };
    case actionTypes.MODIFY_FIELD_OPTION_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };
    case actionTypes.UPDATE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
